import React from 'react';
import { connect } from 'react-redux';
import DataTable from '@/components/DataTable/DataTable';
import { getPortfolioAction } from '@/actions/trading';
import { dataType } from '@/constants/data-type';
import classnames from 'classnames';
import { getSafe } from '@/helpers/global';
import { Comparator, utilsFunction, formatFunctions, writeFileFunctions ,Converter} from '@/helpers/functions';
import { PARAMS as requestParams } from '@/constants/params';
import { WS_LANG_KEY } from '@/constants/app';
import TabHeader from '../TabHeader/TabHeader';
import { stockActions } from '@/actions/trading/stock.action';
import { CUSTOM_STYLES } from '@/constants/app';
import { SERVICES_RESP , history} from '@/configurations';
import Dropdown from '@/components/Dropdown/Dropdown';
import BlockControl from '@/components/BlockControl/BlockControl';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'
import Watchlist from '../Watchlist/Watchlist'
import ExportIconDark from '@/assets/images/icons/light/export_icon_dark.png';
import ExportIconLight from '@/assets/images/icons/light/export_icon_light.png';
import { appConfigConstants } from '@/configurations/app-configs/app.config.constants';
import { openColDefChooseDialog , openPlaceOrderDialog} from '@/actions/app'
import { ACTION_TYPE } from "@/constants/w-socket";
import { WatchlistHelper } from '@/helpers/functions/watchlist.helper';
import { userActions } from '@/actions/user';
import { PATH } from '@/constants/paths';
import { TABLE_CONFIGURABLE_KEYS } from '@/constants/preference';

const icons = {
  exportIcon: {
    dark: ExportIconDark,
    light: ExportIconLight
  }
}
let isOpenDeleteWatchlistCol = false

class Portfolio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'symbol',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SYMBOL,
          minWidth: 100,
          cellRendererParams: {
            action:  this.toQuotePage.bind(this)
          }
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'stockName',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT,
          minWidth:260
        },
        {
          headerName: props.language.common_price,
          colId: 'common_price',
          field: 'price',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 67,
          cellRendererParams: {
            action:  this.openPlaceorder.bind(this)
          }
        },
        {
          headerName: props.language.common_change,
          colId: 'common_change',
          field: 'change',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          bindingColor: true,
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth:142
        },
        {
          headerName: props.language.common_bid,
          colId: 'common_bid',
          field: 'bid',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth:60
        },
        {
          headerName: props.language.common_ask,
          colId: 'common_ask',
          field: 'ask',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-end',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth:60
        },
        {
          headerName: props.language.common_position,
          colId: 'common_position',
          field: 'position',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.NUMBER,
          comparator: Comparator.numberComparator,
          minWidth: 80,
        },
        {
          headerName: props.language.common_market_value,
          colId: 'common_market_value',
          field: 'marketv',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth: 100,
        },
        {
          headerName: props.language.common_today_PL,
          colId: 'common_today_PL',
          field: 'todayPL',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.PERCENT_BASED,
          bindingColor: true,
          comparator: Comparator.numberComparator,
          minWidth: 150,
        },
        {
          headerName: props.language.common_PL_percent,
          colId: 'common_PL_percent',
          field: 'pl',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.PERCENT_BASED,
          bindingColor: true,
          comparator: Comparator.numberComparator,
          minWidth: 200,
        },
        {
          headerName: props.language.common_ccy,
          colId: 'common_ccy',
          field: 'currencyID',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.TEXT,
          minWidth: 60,
        },
        {
          headerName: props.language.common_today_turnover,
          colId: 'common_today_turnover',
          field: 'todayturnover',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CASH,
          comparator: Comparator.numberComparator,
          minWidth: 180
        },
        {
          headerName: props.language.common_today_purchase_price,
          colId: 'common_today_purchase_price',
          field: 'todaypurchase',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 120
        },
        {
          headerName: props.language.common_today_sales_price,
          colId: 'common_today_sales_price',
          field: 'todaysales',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell cell-action',
          dataType: dataType.CURRENCY,
          comparator: Comparator.numberComparator,
          minWidth: 120
        }
      ].filter(Boolean),
      data: null,
      portfolio: [
      {
        id: '1', title: 'portfolio_title', isActive: false,
        children: [
          {
            id: 1, title: 'market_all', value:'' 
          },
          {
            id: 2, title: 'market_hkex', value:'HKEX'
          },
          {
            id: 3, title: 'market_usex',value:'USEX'
          },
          {
            id: 4, title: 'market_stock_connect',value:''
          },
        ]
      },
      {
        id: '2', title: 'watchlist_title', isActive: false,
        children: [
          {
            id: 1, title: 'common_position', value:'position'
          },
          {
            id: 2, title: 'market_all', value:''
          },
          {
            id: 3, title: 'market_hkex', value:'HKEX'
          },
          {
            id: 4, title: 'market_usex', value:'USEX'
          },
          {
            id: 5, title: 'market_stock_connect',value:'CN'
          },
        ]
      },

    ],
      totalMarket: '',
      totalFloatingPL: '',
      totalFloatingPLPercent: '',
      marketCode: '',
      isWatchList : false,
      currentTab :{
        id: '1', title: 'portfolio_title', isActive: false,
        children: [
          {
            id: 1, title: 'market_all', value:'' 
          },
          {
            id: 2, title: 'market_hkex', value:'HKEX'
          },
          {
            id: 3, title: 'market_usex',value:'USEX'
          },
          {
            id: 4, title: 'market_stock_connect',value:''
          },
        ]
      },
      subTab:{
        id: 1, title: 'market_all', value:'' 
      },
      enableDeleteIcon:false,
      preSubTab:{
        id: 1, title: 'market_all', value:'' 
      },
      isrefresh:false,
      notRepeat:false,
      isStockConnect:false,
    }
    props.innerRef(this);
  }

  handleChangeSubTab = (subTab , currentMainTab) => {
    // const marketCode = subTab ? subTab.value: '';
    const marketCode = subTab ? subTab.value? subTab.value : (subTab.value==='' ? '': subTab.name): '';
    const {preSubTab} = this.state
    if (currentMainTab.id === "1") {
      if(JSON.stringify(preSubTab) === JSON.stringify(subTab)) return
      this.setState({
        marketCode,
        subTab,
        preSubTab : subTab,
        isStockConnect : subTab.id === 4
      }, () => {
        this.getPortfolio()
      })
    }else{
      this.setState({
        marketCode,
        subTab,
        preSubTab : subTab
      },()=>{
        if(JSON.stringify(preSubTab) === JSON.stringify(subTab)) return
        if(subTab.isActive) return
        if(marketCode === 'position' ){  
          this.Watchlist.getPostion()
        }else if(marketCode === ''){
          this.Watchlistfiter?.getPostion()   
        }else{
          this.Watchlistfiter?.getWatchLists(marketCode)
        }
      })
    }
    if (subTab && currentMainTab.id === "2") {
      // const { watchlist } = this.props
      let enableDeleteIcon = false
      if(subTab.title==='common_position'){
        enableDeleteIcon = false
      }else if (isOpenDeleteWatchlistCol) {
        // this.handleOpenDelete()
      }
      this.setState({  enableDeleteIcon: enableDeleteIcon }, () => {
        this.initHeader()
      })
    }
    history.push(PATH.TRADE)
  }

  handExportExcelClick = () => {
    const { columnDefs, data } = this.state
    writeFileFunctions.writeExeclFile({ columnDefs, data, fileName: 'Portfolio.xlsx' })
  }

  getPortfolio = () => {
    const { user, currentTradingAccount, language , mdsToken} = this.props
    const { isStockConnect} = this.state;
    const { clientID,tradingAccSeq } = currentTradingAccount
    const params = {
      [requestParams.CLIENT_ID]: clientID,
      [requestParams.TRADING_ACCOUNT_ID]: clientID,
      [requestParams.LANGUAGE]: language.lang,
      [requestParams.MARKET_ID]: this.state.marketCode,
      [requestParams.TRADING_ACC_SEQ]: tradingAccSeq
    }
    this.portfolioRef.toggleLoadingOverlay(true);
    this.setState({data : [] , isrefresh : true})
    this.props.getAccountPortfolio(params, res => {
      if (Array.isArray(res.portfoliosList) && res.portfoliosList.length) {
        const lang = this.props.language.lang
        const sample = ['symbol', 'stockName', 'price', 'change','bid' ,'ask', 'position','marketv','todayPL','pl','currencyID','todayturnover', 'todaypurchase' , 'todaysales'].reduce((prev, next) => (prev[next] = '-', prev), {})
        let filted = []
        if(isStockConnect){
          res.portfoliosList.map(item => {
            if(item.marketID === 'MAMK' || item.marketID === 'SZMK'){
              filted.push(item)
            }
          })
        } else {
          filted = res.portfoliosList
        }
        const data = []
        for (let i = 0; i <  filted.length; i++) {
          const item = filted[i]
          const deepSample = JSON.parse(JSON.stringify(sample))
          deepSample.symbol = [item.marketID, item.stockCode].join('.')
          deepSample.position= item.ledgerQty
          deepSample.pl = `${formatFunctions.dataFormat(item.floatingPL, dataType.CASH)} (${utilsFunction.datatableFormatPercent(item.floatingPLPercent)})`  
          deepSample.todayPL = `${formatFunctions.dataFormat(item.todayFloatingPL, dataType.CASH)} (${utilsFunction.datatableFormatPercent(item.todayFloatingPLPercent)})` 
          deepSample.marketv = item.marketValue
          deepSample.currencyID = item.currencyID
          deepSample.todaypurchase = Number(item.ttodayConfirmBuy)
          deepSample.todaysales = Number(item.ttodayConfirmSell)
          deepSample.marketv = item.marketValue
          if (lang === 'zh_TW' || lang === 'zh_CN') {
            deepSample.stockName = item.stockChineseShortName
            if(!item.stockChineseShortName){
              deepSample.stockName = item.stockName
            }
          } else {
            deepSample.stockName = item.stockName
          }
          if(mdsToken){
            let stockID = item.stockCode.split('').findIndex(i => i !== '0')
          if (stockID > -1) stockID = item.stockCode.substr(stockID)
          const marketID = Converter.mappingWebSocketMarket(item.marketID)
          // const dparams = { instrumentID: item.stockCode, exchangeID: item.marketID }
          if (marketID === "XNYS") {
            const params = { symbols: [{ exchangeID: marketID, key: stockID }] }
            stockActions.getBestBidBestAskAction(params, bestBidBestAskRes => {
              const oneNewRowData = JSON.parse(JSON.stringify(this.state.data))
              const deepSample = oneNewRowData?.[i]
              if (deepSample) {
                deepSample.bid = Array.isArray(bestBidBestAskRes.bestBid) ? bestBidBestAskRes.bestBid?.[0]?.price : bestBidBestAskRes.bestBid?.price
                deepSample.ask = Array.isArray(bestBidBestAskRes.bestAsk) ? bestBidBestAskRes.bestAsk?.[0]?.price : bestBidBestAskRes.bestAsk?.price 
                this.setState({ data: oneNewRowData })
              }
            })
            stockActions.getStatisticsAction(params, statisticsRes => {
              const twoNewRowData = JSON.parse(JSON.stringify(this.state.data))
              const deepSample = twoNewRowData?.[i]
              if (deepSample) {
                deepSample.price = statisticsRes.last
                stockActions.getClosingPriceAction(params, closingPriceRes => {
                  const threeNewRowData = JSON.parse(JSON.stringify(this.state.data))
                  const deepSample = threeNewRowData?.[i]
                  if (deepSample) {
                    deepSample.change = `${utilsFunction.datatableCurrencyFormatter(statisticsRes.last - closingPriceRes.closingPrice)} (${utilsFunction.datatableFormatPercent((statisticsRes.last - closingPriceRes.closingPrice) / closingPriceRes.closingPrice * 100)})`
                    this.setState({ data: threeNewRowData })
                  }
                })
                this.setState({ data: twoNewRowData })
              }
            })
          } else {
            const dparams = {
              symbols: [
                {
                  exchangeID: marketID,
                  key: stockID
                }
              ],
              sessID:mdsToken
            }
            const params = {
              msgType: ACTION_TYPE.SECURITY_FINANCIAL_DATA,
              symbol: { exchangeID: marketID, key: stockID },
              language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
            }
            this.props.getFinancial(params, financialres => {
              if (financialres && Object.keys(financialres).length) {
                const oneNewRowData = JSON.parse(JSON.stringify(this.state.data))
                const deepSample = oneNewRowData[i]
                if(deepSample){
                // Object?.assign(deepSample, { marketv: financialres.marketCap })
                this.props.getDetailPriceInfo(dparams, quetores => {
                  if (quetores && Object.keys(quetores).length) {
                    const twoNewRowData = JSON.parse(JSON.stringify(this.state.data))
                    const deepSample = twoNewRowData[i]
                    if (deepSample) {
                      deepSample.price = quetores.last
                      // deepSample.turnoverRate = quetores.turnoverRate ? quetores.turnoverRate : '-'
                      deepSample.bid = quetores.bids?.[0]?.price
                      deepSample.ask = quetores.asks?.[0]?.price
                      // deepSample.position = quetores.high
                      // deepSample.todayPL = quetores.low
                      deepSample.todayturnover = quetores.turnover
                      
                      deepSample.change = `${utilsFunction.datatableCurrencyFormatter(quetores.last - quetores.prev)} (${utilsFunction.datatableFormatPercent((quetores.last - quetores.prev) / quetores.prev * 100)})`
                      
                      // if (lang === 'zh_TW') {
                      //   deepSample.stockName = quetores.tcName
                      // } else if (lang === 'zh_CN') {
                      //   deepSample.stockName = quetores.scName
                      // } else {
                      //   deepSample.stockName = quetores.name
                      // }
                      this.setState({ data: twoNewRowData })
                    }
                  }
                })
                this.setState({ data: oneNewRowData })
              }
              }
            })
          }

          }
          data.push(deepSample)
        }
        this.setState({ data })
      }
      this.setState({isrefresh:false})
      this.portfolioRef.toggleLoadingOverlay(false);
    })
  }

  componentDidMount() {
    this.portfolioRef.toggleLoadingOverlay(true);
    const { currentTradingAccount, token , mdsToken , userInfo} = this.props
    if (currentTradingAccount && token && mdsToken) {
      if(this.state.notRepeat) return
      this.getPortfolio()
    }
    this.setState({notRepeat:false})
    this.initHeader()
  }

  componentDidUpdate(preProps) {
    const { currentTradingAccount, isNeedRefresh, language ,mdsToken, watchlist} = this.props
    if (JSON.stringify(preProps.currentTradingAccount) !=='{}' && preProps.currentTradingAccount !== currentTradingAccount) {
      this.getPortfolio()
    }
    // if (isNeedRefresh && preProps.isNeedRefresh !== isNeedRefresh) {
    //   if(this.state.currentTab.id === '2') return
    //   this.getPortfolio()
    // }
    if (language && preProps.language !== language) {
      if(this.state.currentTab.id === '2') {
        return
      }
      this.getPortfolio()
    }
    if(preProps.mdsToken != mdsToken && mdsToken){
      if(this.state.currentTab.id === '2') return
      this.getPortfolio()
    }
    if(preProps.watchlist.custom != watchlist.custom){
      this.initHeader()
    }
  }

  componentWillUnmount() {
    this.setState = () => {
      return
    }
  }


  handleChangeMainTab=(mainTab,isback=true)=>{
    if(mainTab.id === '2'){
      this.setState({isWatchList : true , marketCode : 'position' , currentTab : this.depCopy(mainTab),preSubTab:{id: 1, title: 'common_position', value:'position'}, subTab:{id: 1, title: 'common_position', value:'position'}}
      ,()=>{
        this.initHeader()
        if(!isback) return
        this.Watchlist.getPostion()
      }
      )
    }else{
      this.setState({isWatchList : false ,marketCode : '' , currentTab : this.depCopy(mainTab) ,preSubTab:{id: 1, title: 'market_all', value:'' },}
      ,()=>{
        if(!isback) return
        this.getPortfolio()
      }
      )
    }
  }

  handleClickColumnSetting = (currentMainTab,marketCode) => {
    if(currentMainTab.id==='1'){
      openColDefChooseDialog(this.state.columnDefs, res => {
      this.renderFieldAction(res)
    })
    }
    else{
      if(marketCode ==='position'){
        openColDefChooseDialog(this.Watchlist.state?.columnDefs, res => {
        this.renderFieldAction(res,true)
        })
      }else{
        openColDefChooseDialog(this.Watchlistfiter.state?.columnDefs, res => {
          this.renderFieldAction(res,false ,true)
        })
      }
      
    }
    
  }

  renderFieldAction = (fields,isPosition = false , isWatchList = false) => {
    if(isPosition){
      this.Watchlist.setState({ columnDefs: fields })
      this.Watchlist.tableRef.renderColumnDefs(fields)
    }else if(isWatchList){
      this.Watchlistfiter.setState({ columnDefs: fields })
      this.Watchlistfiter.tableRef.renderColumnDefs(fields)
    }else{
      this.setState({ columnDefs: fields })
      this.portfolioRef.renderColumnDefs(fields)
    }
  }

  refresh=(isWatchList,marketCode)=>{
    if(this.state.isrefresh) return
    if(isWatchList){
      this.setState({isrefresh: true})
      if(marketCode === ''){
        this.Watchlistfiter.getPostion(()=>{
          this.setState({isrefresh: false})
        })
      }else if( marketCode === 'position'){
        this.Watchlist.getPostion(()=>{
          this.setState({isrefresh: false})
        })
      }else{
        this.Watchlistfiter.getWatchLists(marketCode,()=>{
          this.setState({isrefresh: false})
        })
      }
    }else{
      this.getPortfolio()
    }
  }
  
  handleOpenDelete = () => {
    isOpenDeleteWatchlistCol = !isOpenDeleteWatchlistCol
    if(this.state.subTab.id !=1){
      this.Watchlistfiter.toggleDeleteColumn(isOpenDeleteWatchlistCol)
    }
  }

  initHeader = (isTriggerChangeTab = false) => {
    const { watchlist } = this.props
    const { currentTab, subTab, enableDeleteIcon } = this.state
    const { custom } = watchlist
    const watchlistOptions = { position: true, addIcon: true, removeIcon: enableDeleteIcon }
    const watchlistFunctions = { handleOpenDelete: this.handleOpenDelete }
    const watchlistChildren = WatchlistHelper.getTabHeader(custom, null, watchlistOptions, watchlistFunctions, '', subTab.id)
    const tabs = [
      {
        id: '1', title: 'portfolio_title', isActive: currentTab.title === 'portfolio_title',
        children: [
          {
            id: 1, title: 'market_all', value: '' 
          },
          {
            id: 2, title: 'market_hkex', value: 'HKEX'
          },
          {
            id: 3, title: 'market_usex', value: 'USEX'
          },
          {
            id: 4, title: 'market_stock_connect',value:''
          },
        ]
      },
      { id: '2', title: 'watchlist_title', children: watchlistChildren, isActive: currentTab.title === 'watchlist_title' },
    ]
    this.setState({ portfolio: tabs }, () => {
      // setTimeout(() => {
      //   const currentActiveTab = this.tabHeaderRef.getCurrentTab()
      //   isTriggerChangeTab && this.handleChangeTab(currentActiveTab)
      // }, 150)
    })
  }

  UNSAFE_componentWillMount() {
    if(history){
      const { location } = history
      if(location.state){
        const { history } = location.state
        if(history === PATH.TRADE){
          for(let i=0;i<this.state.portfolio.length;i++){
            if(this.state.portfolio[i].id === location.state.currentTab.id){
              this.state.portfolio[i].isActive = true
              for(let j=0;j<this.state.portfolio[i].children.length;j++){
                if(this.state.portfolio[i].children[j].id === location.state.subTab.id){
                  this.state.portfolio[i].children[j].isActive=true
                }
              }
            }
          }
          this.setState({currentTab:location.state.currentTab,subTab:location.state.subTab,notRepeat:true},()=>{
            this.tabheader.handleChangeMainTab(location.state.currentTab,false)
            this.handleChangeSubTab(location.state.subTab,location.state.currentTab)
          })
        }
      }
    }
  }

  checktype=(obj) =>{
    return Object.prototype.toString.call(obj).slice(8, -1)
  }
  depCopy=(target, hash = new WeakMap())=> {
    let type = this.checktype(target)
    let result = null
    if (type == 'Object') {
      result = {}
    } else if (type == 'Array') {
      result = []
    } else {
      return target
    }
    if (hash.has(target)) {
      return hash.get(target)
    }
    hash.set(target, result) 
    for (let i in target) {
      if (
        this.checktype(target[i]) == 'Object' ||
        this.checktype(target[i]) == 'Array'
      ) {
        result[i] = this.depCopy(target[i], hash) 
      } else {
        result[i] = target[i]
      }
    }
    return result
  }

  handleClickSymbol=(marketID,StockID)=>{
    let  currentSelect = Array.isArray(this.state.subTab) ? {id:1,title:"market_all",value:''} : this.state.subTab.title === 'market_stock_connect' ?  {id:4,title:"market_stock_connect",value:'CN'}  : this.state.subTab
    history.push(PATH.MARKET_DATA,{marketID:marketID,StockID:StockID ,search:'marketinfo',chart:true , currentTab:[],subTab:[],history:PATH.TRADE,currentSelect})
  }

  openPlaceorder=(data)=>{
    let marketID = data.symbol.split('.')[0]
    const datalist = {
      marketID: marketID,
      instrumentID:data.symbol.split('.')[1],
      price : data.price,
      quantity:data.position
    }
    let marketList = []
    this.props.markets.map(item=>{
      marketList.push(item.value)
    })
    if(!marketList.includes(marketID)){
      return
    }
    this.props.setPlaceOrderParams(datalist)
    // openPlaceOrderDialog(null,datalist,true)
  }
  
  toQuotePage = (data) => {
    if(this.state.refresh) return
    let stock = data.symbol
    const marketID = stock.substring(0, stock.indexOf("."))
    let marketList = []
    this.props.markets.map(item=>{
      marketList.push(item.value)
    })
    if(!marketList.includes(marketID)){
      return
    }
    if (marketID === 'USEX') {
      const stockID = stock?.split('.')?.[1]
      this.props.setStock({ stockCode: stockID, marketID }, () => {
        this.handleClickSymbol(marketID, stockID)
      })
    } else {
      let stockID = stock.substring(stock.indexOf(".") + 1).split('').findIndex(i => i !== '0')
      if (stockID > -1) {
        stockID = stock.substring(stock.indexOf(".") + 1).substr(stockID)
      }
      // if(this.props.profile){
        this.props.setStock({ stockCode: utilsFunction.instrumentIDZeroPadding(stockID), marketID: stock.substring(0, stock.indexOf(".")) }, () => {
          this.handleClickSymbol(stock.substring(0, stock.indexOf(".")),utilsFunction.instrumentIDZeroPadding(stockID))
        })
      // }
    }
  }

  render() {
    const { language, isMobile, markets, isFilter, autoSize, tabHeader, theme } = this.props;
    const { data, columnDefs, portfolio, totalFloatingPLPercent, totalFloatingPL, totalMarket , isWatchList , marketCode} = this.state;
    return (
      <React.Fragment>
        <div className={classnames("section-table")}>
          {
            tabHeader && <TabHeader tabs={portfolio} refresh  onRefresh={() => this.refresh(isWatchList,marketCode)}
              marketFilter={!isFilter && !iTradeEnv?.pages?.trade?.ctrl?.marketFilter} handleChangeSubTab={this.handleChangeSubTab} 
              onChangeMainTab = {this.handleChangeMainTab}
              innerRef={c => this.tabheader = c}
              onClickColumnSetting ={(currentMainTab)=>this.handleClickColumnSetting(currentMainTab,marketCode)}
            />
          }
          {
            isFilter && <div className={classnames("section-action-panel")}>
              <span>{getSafe(() => language.common_market)}:</span>
              <div className={classnames("section-action-box", "border-style")}>
                <Dropdown selectedOptions={[markets[0]]}
                  options={markets}
                  innerRef={(e) => this.marketRef = e}
                  onChange={(mrk) => this.handleChangeSubTab(mrk[0])}
                >
                </Dropdown>
              </div>
              <div className="section-action-box">
                <div className="open-market">
                  <span className="open-market-label">{getSafe(() => language.portfolio_market_value)}:</span>
                  <span className="margin-10">{totalMarket ? formatFunctions.dataFormat(totalMarket,dataType.CASH) : '-'}</span>
                </div>
                {/* {
                  appEnvironment.custom_ctr_configs.accountCtr.enableFloatPL &&
                  <React.Fragment>
                    <div>
                      {getSafe(() => language.portfolio_float_PL)}:
              <span className={classnames(this.bindingColor(totalFloatingPL), "margin-10")}>
                        {utilsFunction.currencyFormatter(totalFloatingPL)}
                      </span>
                    </div>
                    <div>
                      {getSafe(() => language.portfolio_float_PL_percent)}:
                <span className={classnames(this.bindingColor(totalFloatingPL), "margin-10")}>
                        {utilsFunction.currencyFormatter(totalFloatingPLPercent, 2)}%
                </span>
                    </div>
                  </React.Fragment>
                } */}
              </div>
              <BlockControl auth={appConfigConstants.exportExeclFile}>
                <div className="action-item export-file-wrapper">
                  <button className="export-excel-btn" onClick={this.handExportExcelClick}>
                    <img className="export-icon" src={icons.exportIcon[theme]} />
                    <span>{language.common_export_execl}</span>
                  </button>
                </div>
              </BlockControl>
            </div>
          }
         {isWatchList ? <Watchlist onRef={c=>this.Watchlist=c} innRef={c => {
           this.Watchlistfiter = c
         }} marketCode={marketCode} isWatchList={isWatchList} onClickSymbol={this.handleClickSymbol}/> :
          <DataTable
            name={TABLE_CONFIGURABLE_KEYS.TRADE_PORTFOLIO_ALL}
            columnDefs={columnDefs}
            data={data}
            innerRef={e => this.portfolioRef = e}
            // autoSizeColumns={autoSize}
          />
          }    
        </div>
      </React.Fragment>
    )
  }


  bindingColor(value) {
    if (value > 0) {
      return 'rise-color'
    } else if (value < 0) {
      return 'fall-color'
    } else {
      return ''
    }
  }
}

Portfolio.defaultProps = {
  isFilter: false,
  autoSize: true,
  tabHeader: true,
  innerRef: () => { },
}

export default connect(
  state => ({
    language: state.app.language,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    markets: [{ label: state.app.language.market_all, value: '' }, ...state.trade.markets],
    isNeedRefresh: state.refresh.marketAction,
    token: state.auth.token,
    theme: state.app.theme,
    mdsToken: state.trade.mdsToken,
    userInfo: state.user.userInfo,
    watchlist: state.user.watchlist
  }),
  dispatch => ({
    getAccountPortfolio: (p, c) => dispatch(getPortfolioAction(p, c)),
    getDetailPriceInfo: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    getFinancial: (p, c) => stockActions.getFinancialAction(p, c),
    getInstrumentWatchlistAction:(p,c) =>dispatch(userActions.getInstrumentWatchlistAction(p, c)),
    setStock: (p, res) => dispatch(stockActions.setMarketStockAction(p, res)),
    setPlaceOrderParams: (p) => dispatch(stockActions.setPlaceOrderParamsAction(p))
  })
)(Portfolio)
